var $3d8c6e7a5ed266c1$exports = {};
$3d8c6e7a5ed266c1$exports = {
    "invalidSelection": (args, formatter)=>`Geselecteerde ${formatter.plural(args.selectedCount, {
            one: `datum`,
            other: `datums`
        })} niet beschikbaar.`
};


export {$3d8c6e7a5ed266c1$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
